import "../components/styles/app.css";
import app from "../images/phone.webp";
import apple from "../images/appStore.webp";
import google from "../images/googlePlay.webp";

export default function App() {
  return (
    <section className="app" id="download-app">
      <div className="app-inner">
        <div className="app-copy">
          <span className="app-kicker">TUBBEES REWARDS</span>

          <h2>
            More slush.
            <br />
            <em>More perks.</em>
          </h2>

          <p className="app-intro">
            Your next favourite flavour is only a tap away. Join the Tubbees
            app to collect points, unlock rewards, and get first dibs on new
            treats.
          </p>

          <div className="app-benefits" aria-label="App benefits">
            <div className="app-benefit">
              <span>01</span>
              <strong>Collect points</strong>
            </div>
            <div className="app-benefit">
              <span>02</span>
              <strong>Unlock treats</strong>
            </div>
            <div className="app-benefit">
              <span>03</span>
              <strong>Treat yourself</strong>
            </div>
          </div>

          <div className="app-download">
            <span>Available on</span>

            <div className="store">
              <a
                href="https://apps.apple.com/gb/app/tubbees-loyalty/id6738990046"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Download Tubbees from the App Store"
              >
                <img src={apple} alt="Download on the App Store" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.tubbees"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Get Tubbees on Google Play"
              >
                <img src={google} alt="Get it on Google Play" />
              </a>
            </div>
          </div>
        </div>

        <div className="app-visual" aria-hidden="true">
          <div className="app-sticker app-sticker-top">TAP. SIP. REPEAT.</div>
          <div className="app-orbit app-orbit-one" />
          <div className="app-orbit app-orbit-two" />
          <div className="app-phone-wrap">
            <img src={app} alt="" />
          </div>
          <div className="app-sticker app-sticker-bottom">FREE SLUSHEES</div>
        </div>
      </div>
    </section>
  );
}
